import React, { useState } from "react";

function SystemRestart() {
  const [restartTime, setRestartTime] = useState("");

  const handleRestart = () => {
    if (restartTime) {
      alert(`System restart scheduled at ${restartTime}.`);
      setRestartTime("");
    } else {
      alert("Please select a restart time.");
    }
  };

  return (
    <div>
      {/* Header Section */}
      <div className="bg-blue-50 p-6 rounded-lg mb-6">
        <h2 className="text-lg font-bold text-blue-800 mb-2">System Restart</h2>
        <p className="text-xs text-gray-600">
          Schedule a system restart at a convenient time. Select the desired restart time from the options below.
        </p>
      </div>

      {/* Restart Time Selection Section */}
      <div className="bg-gray-100 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Choose Restart Time</h3>

        <div className="space-y-4 mb-6">
          <label className="block">
            <span className="text-xs text-gray-700">Select Time:</span>
            <input
              type="time"
              value={restartTime}
              onChange={(e) => setRestartTime(e.target.value)}
              className="mt-2 p-2 border rounded-md w-full focus:ring-blue-500 focus:border-blue-500 text-xs"
            />
          </label>
        </div>

        <button
          onClick={handleRestart}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded-lg shadow-md transition text-xs"
        >
          Schedule Restart
        </button>

        {/* Restart Information */}
        {restartTime && (
          <div className="mt-4 p-4 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
            <p className="text-xs text-blue-800">
              <strong>Restart Time:</strong> {restartTime}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SystemRestart;